module.exports = __webpack_public_path__ + "static/cyber-essentials-logo-v2-206d8aa65c8b1fcf87d111e5ab7e737c.png";